import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  TemplateRef,
  OnDestroy,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { HttpClient } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import * as _ from "lodash";
import { DatePipe } from "@angular/common";
import { TranslationService } from "../../language/translation.service";

@Component({
  selector: "app-edit-product",
  templateUrl: "./edit-product.component.html",
  styleUrls: ["./edit-product.component.scss"],
})
export class EditProductComponent implements OnInit, OnDestroy {
  @Output() emitList = new EventEmitter();
  @Output() emitClose = new EventEmitter();
  @Input() orgData: ModifyPRDProductReq;
  @Input() info: {
    IsLoding: boolean,
    moType: number,
    orgType: number,
    pdShowType: number,
    pfType: number,
    IsAIConentTranslate?: boolean,
    RemainingSYSQuota?: number,
    RemainingQuota?: number,
    ORG_Store_ID: null,
    groupList: selectData[],
    isChange_Group: boolean,
    PRDGroupNo: null,
    PRDMenuProductGroupNo: null,
    storeList: selectData[],
    memberTypeList: memberData[],
    PRDProductGroupNo: null,
    PRDProductNo: null,
  };

  moTitle: string;
  title2: string;
  mealData: ModifyPRDProductReq;
  USR_AccountInfo_ID: string;
  USR_EmployeeInfo_ID: string;
  USR_POSEmployeeInfo_ID: number;
  AIUSR_AccountInfo_ID: string;
  ORG_Company_ID: number;
  ORG_Store_ID: number;
  authChangeSub: any;
  languageChangeSub: any;
  testFiles;
  TaxRateList = [];
  TaxTypeList = [];
  selectReady = false;
  aiSuggestionContent = "";
  aiLoading = false;

  @ViewChild("Modal") Modal: TemplateRef<any>;
  modalRef = null;
  @ViewChild("DayModal") DayModal: TemplateRef<any>;
  dayModalRef = null;

  constructor(
    private http: HttpClient,
    private dialogService: NbDialogService,
    private cookieService: CookieService,
    private datePipe: DatePipe,
    private translationService: TranslationService,
  ) {
    this.AIUSR_AccountInfo_ID = this.cookieService.get("USR_AccountInfo_ID") || null;
    this.USR_POSEmployeeInfo_ID = this.cookieService.get("USR_POSEmployeeInfo_ID")
      ? parseInt(this.cookieService.get("USR_POSEmployeeInfo_ID"))
      : null;
    this.USR_AccountInfo_ID = this.cookieService.get("USR_AccountInfo_ID")
      ? "USR_AccountInfo_ID_" + this.cookieService.get("USR_AccountInfo_ID")
      : this.cookieService.get("USR_POSEmployeeInfo_ID")
        ? "USR_POSEmployeeInfo_ID" + this.cookieService.get("USR_POSEmployeeInfo_ID")
        : null;
    this.USR_EmployeeInfo_ID = this.cookieService.get("USR_EmployeeInfo_ID");
    this.ORG_Company_ID = parseInt(this.cookieService.get("ORG_Company_ID"));
    const cookieSid = this.cookieService.get("ORG_Store_ID");
    this.ORG_Store_ID = cookieSid && cookieSid !== "" ? parseInt(cookieSid) : null;
  }

  ngOnInit(): void {
    for (let i = 1; i < 100; i++) {
      this.TaxRateList.push({ value: i, content: i + "%" });
    }
    this.applyTranslations();
    this.refreshSelects();
    this.languageChangeSub = this.translationService.languageChanged$.subscribe(() => {
      this.applyTranslations();
      this.refreshSelects();
    });
  }

  ngOnDestroy() {
    if (this.languageChangeSub) {
      this.languageChangeSub.unsubscribe();
    }
  }

  ngAfterViewInit() {
    this.onOpen(this.info, this.orgData);
  }

  onOpen(info, data) {
    if (info) {
      this.info = info;
    }

    this.mealData = new ModifyPRDProductReq();
    this.aiSuggestionContent = "";
    this.mealData.IsAIConentTranslate = !!this.info?.IsAIConentTranslate;
    this.mealData.RemainingSYSQuota = this.info?.RemainingSYSQuota ?? 0;
    this.mealData.RemainingQuota = this.info?.RemainingQuota ?? 0;

    if (this.info.moType == 1) {
      this.moTitle = this.tt("common_add", "新增");
      this.mealData.PRDGroupNo = this.info.PRDGroupNo;
      this.mealData.PRDMenuProductGroupNo = this.info.PRDMenuProductGroupNo;
    } else if (this.info.moType == 2) {
      this.moTitle = this.tt("common_edit", "編輯");
      if (data) {
        this.toProductDetail(data);
      }
    } else if (this.info.moType == 3) {
      this.moTitle = this.tt("common_copy", "複製");
      if (data) {
        this.toProductDetail(data);
        this.mealData.PRDProductNo = null;
      }

      if (this.info.orgType == 1) {
        this.getStoreList();
      }
    } else if (this.info.moType == 4) {
      this.moTitle = this.tt("common_view", "查看");
      if (data) {
        this.toProductDetail(data);
      } else {
        this.getProductDetail(null);
      }
    }

    if (this.info.orgType == 1) {
      this.title2 = this.tt("common_default_data", "預設資料");
    } else if (this.info.orgType == 2) {
      this.title2 = this.tt("common_adjustable_data", "可調整資料");
      if (this.mealData.SupplyQTY == null) {
        this.mealData.SupplyQTY = 10000;
      }
    } else if (this.info.orgType == 3) {
      this.title2 = this.tt("common_sale_data", "販售資料");
    }

    if (!info.pdShowType) {
      info.pdShowType = 1;
    }

    this.modalRef = this.dialogService.open(this.Modal, {});
    this.modalRef.onClose.subscribe(() => {
      this.emitClose.emit(true);
    });
  }

  applyAiSuggestion() {
    if (this.info.moType == 4 || this.info.orgType == 2 || !this.aiSuggestionContent || this.aiSuggestionContent.trim() === "") {
      return;
    }

    this.mealData.ProductContant = this.aiSuggestionContent;
  }

  getAiSuggestionRemainingCount(): number {
    return Number(this.mealData?.RemainingSYSQuota || 0) + Number(this.mealData?.RemainingQuota || 0);
  }

  private refreshAiSuggestionQuota(): void {
    const par = {
      ORG_Company_ID: this.ORG_Company_ID,
      ORG_Store_ID: this.info?.ORG_Store_ID ?? this.ORG_Store_ID,
    };

    this.http.post<any>("api/ProductSetting/getMemberTypes", par).subscribe({
      next: (data) => {
        this.mealData.RemainingSYSQuota = data?.RemainingSYSQuota ?? 0;
        this.mealData.RemainingQuota = data?.RemainingQuota ?? 0;
        if (this.info) {
          this.info.RemainingSYSQuota = this.mealData.RemainingSYSQuota;
          this.info.RemainingQuota = this.mealData.RemainingQuota;
        }
      },
      error: (error) => {
        console.error("Refresh AI suggestion quota error!", error);
      }
    });
  }

  generateAiSuggestion() {
    if (this.info.moType == 4 || this.info.orgType == 2) {
      return;
    }

    if (!this.mealData?.ProductName || this.mealData.ProductName.trim() === "") {
      alert("請先輸入商品名稱");
      return;
    }

    this.aiLoading = true;
    this.aiSuggestionContent = "";

    const req = {
      USR_AccountInfo_ID: this.AIUSR_AccountInfo_ID,
      USR_POSEmployeeInfo_ID: this.USR_POSEmployeeInfo_ID,
      ORG_Company_ID: this.ORG_Company_ID,
      ORG_Store_ID: this.ORG_Store_ID,
      AIORG_Company_ID: this.ORG_Company_ID,
      AIORG_Store_ID: this.ORG_Store_ID,
      PRDProductNo: this.mealData.PRDProductNo,
      PRDGroupNo: this.mealData.PRDGroupNo,
      ProductName: this.mealData.ProductName,
      ProductContant: this.mealData.ProductContant || "",
    };

    this.http.post<any>("api/ProductSetting/AiBeautifyProductDescription", req).subscribe({
      next: (data) => {
        this.aiSuggestionContent = data?.Content || "";
        this.refreshAiSuggestionQuota();
        this.aiLoading = false;
      },
      error: (error) => {
        console.error("There was an error!", error);
        alert(error?.error?.RESULT || "AI介紹美化失敗");
        this.aiLoading = false;
      }
    });
  }

  onSave() {
    if (!this.mealData.Cash && this.mealData.Cash != 0) {
      alert(this.tt("common_product_original_price_required", "???敹?憛?"));
      return null;
    }
    if (!this.mealData.SaleCash && this.mealData.SaleCash != 0) {
      alert(this.tt("common_product_price_required", "???桀敹?憛?"));
      return null;
    }

    if (this.mealData.supplyPeriod && this.mealData.supplyPeriod.length) {
      if (this.mealData.supplyPeriod.length >= 1) {
        this.mealData.FirstSupplyStartTime =
          this.datePipe.transform(this.mealData.supplyPeriod[0].startTime, "yyyy/MM/dd HH:mm:ss");
        this.mealData.FirstSupplyEndTime =
          this.datePipe.transform(this.mealData.supplyPeriod[0].endTime, "yyyy/MM/dd HH:mm:ss");

        if (this.mealData.supplyPeriod[0].startTime > this.mealData.supplyPeriod[0].endTime) {
          alert(this.tt("common_start_date_greater_than_end", "???交?銝憭扳蝯??交?!"));
          return;
        }
      }

      if (this.mealData.supplyPeriod.length >= 2) {
        this.mealData.SecondSupplyStartTime =
          this.datePipe.transform(this.mealData.supplyPeriod[1].startTime, "yyyy/MM/dd HH:mm:ss");
        this.mealData.SecondSupplyEndTime =
          this.datePipe.transform(this.mealData.supplyPeriod[1].endTime, "yyyy/MM/dd HH:mm:ss");

        if (this.mealData.supplyPeriod[1].startTime > this.mealData.supplyPeriod[1].endTime) {
          alert(this.tt("common_start_date_greater_than_end", "???交?銝憭扳蝯??交?!"));
          return;
        }
      }
    } else {
      this.mealData.FirstSupplyStartTime = "";
      this.mealData.FirstSupplyEndTime = "";
      this.mealData.SecondSupplyStartTime = "";
      this.mealData.SecondSupplyEndTime = "";
    }

    let checkMember = null;
    if (this.mealData.ProductLevelMapJsonData) {
      checkMember = this.mealData.ProductLevelMapJsonData.map(item => JSON.parse(JSON.stringify(item)));
      for (let i = 0; i < checkMember.length; i++) {
        const item = checkMember[i];
        for (const key in item) {
          if (item[key] === "" || item[key] === null) {
            alert(this.tt("common_special_price_incomplete", "?寞??寞閮剖??芸‵撖怠???"));
            return;
          }
        }
        const ids = item.usrMemberLevelIDs.split(",");
        const names = item.memberLevelNames.split("、");
        if (ids.includes("0") && names.includes(this.t("product_apply_all"))) {
          item.usrMemberLevelIDs = null;
          item.memberLevelNames = "";
        }
      }
    }

    if (this.mealData.files && this.mealData.files.length > 0) {
      this.mealData.Image = this.mealData.files[0].path;
    }

    let attachItemGroups = "";
    if (this.mealData.AttachItemGroupJsonDatas) {
      const data = _.orderBy(this.mealData.AttachItemGroupJsonDatas, x => ["Sorting"], ["asc"]);
      data.forEach((item) => {
        attachItemGroups = attachItemGroups === ""
          ? item.PRDMenuAttachItemGroupNo
          : attachItemGroups + "," + item.PRDMenuAttachItemGroupNo;
        item.Sorting = item.Sorting * 1;
      });
    }
    this.mealData.AttachItemGroupJsonData = attachItemGroups;

    const Main = {
      ProductName: this.mealData.ProductName,
      ProductContant: this.mealData.ProductContant,
      Image: this.mealData.Image,
      TaxRate: this.mealData.TaxRate,
      TaxType: this.mealData.TaxType,
      Cash: this.mealData.Cash,
    };
    const Detail = {
      SaleCash: this.mealData.SaleCash,
      Sorting: this.mealData.Sorting,
      IsOpenTakeout: this.mealData.IsOpenTakeout,
      IsOpenDelivery: this.mealData.IsOpenDelivery,
      IsOpenDining: this.mealData.IsOpenDining,
      IsOpenSelfPickup: this.mealData.IsOpenSelfPickup,
      IsOpenReserveDining: this.mealData.IsOpenReserveDining,
      IsChangeCash: this.mealData.IsChangeCash,
      SupplyQTY: this.mealData.SupplyQTY,
      UplimitQTY: this.mealData.UplimitQTY,
      SupplyDay: this.mealData.SupplyDay,
      FirstSupplyStartTime: this.mealData.FirstSupplyStartTime,
      FirstSupplyEndTime: this.mealData.FirstSupplyEndTime,
      SecondSupplyStartTime: this.mealData.SecondSupplyStartTime,
      SecondSupplyEndTime: this.mealData.SecondSupplyEndTime,
      AttachItemGroupJsonDatas: this.mealData.AttachItemGroupJsonDatas,
      AttachItemGroupJsonData: this.mealData.AttachItemGroupJsonData,
      ProductLevelMapJsonData: checkMember,
    };
    this.mealData.Main = Main;
    this.mealData.Detail = Detail;
    this.mealData.ORG_Company_ID = this.ORG_Company_ID;
    this.mealData.USR_EmployeeInfo_ID = parseInt(this.USR_EmployeeInfo_ID);
    this.mealData.USR_AccountInfo_ID = this.USR_AccountInfo_ID;

    if (this.mealData.TaxType != 2) {
      const userConfirmed = confirm(this.tt("common_product_tax_confirm", "??蝔??蝔??臬蝜潛??脣??"));
      if (userConfirmed) {
        this.emitList.emit(this.mealData);
      }
      return null;
    }
    this.emitList.emit(this.mealData);
  }

  addSupplyData() {
    if (this.mealData.supplyPeriod == null) {
      this.mealData.supplyPeriod = [];
    }
    if (this.mealData.supplyPeriod.length >= 2) {
      return;
    }
    this.mealData.supplyPeriod.push(new supplyPeriod());
  }

  delSupplyData(idx) {
    this.mealData.supplyPeriod.splice(idx, 1);
  }

  addSupplyTime() {
    this.dayModalRef = this.dialogService.open(this.DayModal, {});
  }

  showSupplyTime() {
    const str = [];
    const value = [];
    this.mealData.SupplyDay = "";
    if (this.mealData.supplyTimeMonday) { str.push(this.t("common_monday")); value.push("1"); }
    if (this.mealData.supplyTimeTuesday) { str.push(this.t("common_tuesday")); value.push("2"); }
    if (this.mealData.supplyTimeWednesday) { str.push(this.t("common_wednesday")); value.push("3"); }
    if (this.mealData.supplyTimeThursday) { str.push(this.t("common_thursday")); value.push("4"); }
    if (this.mealData.supplyTimeFriday) { str.push(this.t("common_friday")); value.push("5"); }
    if (this.mealData.supplyTimeSaturday) { str.push(this.t("common_saturday")); value.push("6"); }
    if (this.mealData.supplyTimeSunday) { str.push(this.t("common_sunday")); value.push("7"); }

    if (str.length > 0) {
      this.mealData.supplyDayStr = str.join(",");
      this.mealData.SupplyDay = value.join(",");
    }

    if (this.dayModalRef) {
      this.dayModalRef.close();
    }

    return str;
  }

  fileToBase64 = (file: File): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.toString());
      reader.onerror = (error) => reject(error);
    });
  };

  onSelect(event, dataBox) {
    dataBox.files = [];

    if (event.addedFiles == null || event.addedFiles.length == 0) {
      return;
    }

    const self = this;
    const checks = event.addedFiles.map(file => {
      return new Promise((resolve, reject) => {
        if (file.size > 20 * 1024 * 1024) {
          alert(this.tt("common_file_size_limit_20mb", "檔案大小不能超過20MB"));
          return reject();
        }

        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          if (img.width > 2000 || img.height > 2000) {
            alert(this.tt("common_image_max_2000", "圖片的長和寬都要小於2000像素"));
            return reject();
          }
          if (img.width < 320 || img.height < 320) {
            alert(this.tt("common_image_min_320", "圖片的長和寬都要大於320像素"));
            return reject();
          }
          resolve(file);
        };
      });
    });

    Promise.all(checks).then(() => {
      dataBox.files.push(event.addedFiles[0]);

      if (dataBox.files && dataBox.files[0]) {
        for (let i = 0; i < dataBox.files.length; i++) {
          self.fileToBase64(dataBox.files[i]).then((result) => {
            const imgdata = {
              base64: result,
              functionType: "1",
              ORG_Company_ID: self.ORG_Company_ID,
              ORG_Store_ID: self.info.ORG_Store_ID,
            };

            self.info.IsLoding = true;
            self.http.post<any>("api/ImageUpload/ImageUpload", imgdata).subscribe({
              next: (data) => {
                dataBox.files[0].path = data.path;
                self.info.IsLoding = false;
              },
              error: () => {
                self.info.IsLoding = false;
              },
            });
          });
        }
      }
    }).catch(() => {
      self.info.IsLoding = false;
    });
  }

  onRemove(event, dataBox) {
    dataBox.files = [];
    if (dataBox.Image) {
      dataBox.Image = "";
    }
    event.stopPropagation();
  }

  Remove(event, dataBox) {
    dataBox.files = [];
    if (dataBox.Image) {
      dataBox.Image = "";
    }
  }

  onSelectStore() {
    this.getGroupList();
  }

  toProductDetail(data) {
    if (this.info.orgType != 3) {
      this.mealData = Object.assign(this.mealData, data, data.Main, data.Detail);
    } else {
      this.mealData = Object.assign(this.mealData, data);
    }

    if (this.mealData.SupplyDay != null && this.mealData.SupplyDay !== "") {
      const myArray = this.mealData.SupplyDay.split(",");
      myArray.forEach((day) => {
        if ("1" == day) this.mealData.supplyTimeMonday = true;
        if ("2" == day) this.mealData.supplyTimeTuesday = true;
        if ("3" == day) this.mealData.supplyTimeWednesday = true;
        if ("4" == day) this.mealData.supplyTimeThursday = true;
        if ("5" == day) this.mealData.supplyTimeFriday = true;
        if ("6" == day) this.mealData.supplyTimeSaturday = true;
        if ("7" == day) this.mealData.supplyTimeSunday = true;
      });
      this.showSupplyTime();
    }

    this.mealData.supplyPeriod = [];
    if (this.mealData.FirstSupplyStartTime != null) {
      let tmp = new supplyPeriod();
      tmp.startTime = new Date(this.mealData.FirstSupplyStartTime);
      tmp.endTime = new Date(this.mealData.FirstSupplyEndTime);
      this.mealData.supplyPeriod.push(tmp);

      if (this.mealData.SecondSupplyStartTime != null) {
        tmp = new supplyPeriod();
        tmp.startTime = new Date(this.mealData.SecondSupplyStartTime);
        tmp.endTime = new Date(this.mealData.SecondSupplyEndTime);
        this.mealData.supplyPeriod.push(tmp);
      }
    }
  }

  @ViewChild("ProductLevelSettingMO_Tmp", { static: false }) ProductLevelSettingMO_Tmp;
  ProductLevelSettingMO = {
    data: null,
    USR_MemberLevel_IDList: null,
    showData: [],
    isShow: false,
    index: null,
    onOpen: (data, index) => {
      const my = this.ProductLevelSettingMO;
      my.data = [];
      my.data = this.info.memberTypeList;
      my.USR_MemberLevel_IDList = [];
      if (data.usrMemberLevelIDs && data.usrMemberLevelIDs.trim() !== "") {
        my.USR_MemberLevel_IDList = data.usrMemberLevelIDs.split(",").map(Number);
      } else {
        my.USR_MemberLevel_IDList = [];
      }
      my.index = index;
      my.isShow = true;
    },
    onSave: (data) => {
      const ProductLevel = this.mealData.ProductLevelMapJsonData;
      ProductLevel[data.index].usrMemberLevelIDs = data.filteredList.map(member => member.USR_MemberLevel_ID).join(",");
      ProductLevel[data.index].memberLevelNames = data.filteredList.map(member => member.MemberLevelName).join("、");

      const removableNos = data.filteredList.map(member => member.USR_MemberLevel_ID).join(",");
      const removableNames = data.filteredList.map(member => member.MemberLevelName).join("、");

      ProductLevel.forEach((item, index) => {
        if (index !== data.index) {
          let itemNos = item.usrMemberLevelIDs.split(",");
          let itemNames = item.memberLevelNames.split("、");
          itemNos = itemNos.filter(no => !removableNos.includes(no));
          itemNames = itemNames.filter(name => !removableNames.includes(name));
          item.usrMemberLevelIDs = itemNos.join(",");
          item.memberLevelNames = itemNames.join("、");
        }
      });
    },
    onDel: (index: number) => {
      const ProductLevel = this.mealData.ProductLevelMapJsonData;
      ProductLevel.splice(index, 1);
    },
    onClose(v) {
      this.isShow = false;
    },
    onAddShow: () => {
      if (!this.mealData.ProductLevelMapJsonData) {
        this.mealData.ProductLevelMapJsonData = [];
      }
      const ProductLevel = this.mealData.ProductLevelMapJsonData;
      ProductLevel.push({
        usrMemberLevelIDs: "",
        memberLevelNames: "",
        takeoutSaleCash: null,
        deliverySaleCash: null,
        diningSaleCash: null,
        selfPickupSaleCash: null,
      });
    },
  };

  @ViewChild("SelectAttMMO_Tmp", { static: false }) SelectAttMMO_Tmp;
  SelectAttMMO = {
    info: {},
    isShow: false,
    data: null,
    other: {
      attList: [],
    },
    onOpen: () => {
      this.SelectAttMMO.data = [];
      this.SelectAttMMO.isShow = true;
    },
    onSave: (data) => {
      if (!this.mealData.AttachItemGroupJsonDatas) {
        this.mealData.AttachItemGroupJsonDatas = [];
      }

      const list = [];
      data.forEach(p => {
        if (this.mealData.AttachItemGroupJsonDatas.findIndex(x => x.PRDMenuAttachItemGroupNo == p.No) == -1) {
          p.Sorting = 0;
          list.push(p);
        }
      });

      this.mealData.AttachItemGroupJsonDatas = this.mealData.AttachItemGroupJsonDatas.concat(list);
      this.mealData.AttachItemGroupJsonDatas.forEach((item, index) => {
        item.Sorting = index + 1;
      });
    },
    onClose(v) {
      this.isShow = false;
    },
  };

  @ViewChild("SelectAttGMO_Tmp", { static: false }) SelectAttGMO_Tmp;
  SelectAttGM = {
    info: {
      ORG_Company_ID: null,
      ORG_Store_ID: null,
    },
    isShow: false,
    data: null,
    onOpen: () => {
      if (this.mealData.AttachItemGroupJsonDatas) {
        this.SelectAttGM.data = _.cloneDeep(this.mealData.AttachItemGroupJsonDatas);
      }
      this.SelectAttGM.info = {
        ORG_Company_ID: this.ORG_Company_ID,
        ORG_Store_ID: this.ORG_Store_ID,
      };
      this.SelectAttGM.isShow = true;
    },
    onSave: (data) => {
      this.mealData.AttachItemGroupJsonDatas = data;
    },
    onClose(v) {
      this.isShow = false;
    },
  };

  @ViewChild("EditAttachGMO_Tmp", { static: false }) EditAttachGMO_Tmp;
  EditAttachGMO = {
    info: {
      ORG_Company_ID: null,
      ORG_Store_ID: null,
      GroupNo: null,
      moType: null,
      orgType: null,
    },
    isShow: false,
    data: {},
    onOpen: (type, data) => {
      this.EditAttachGMO.info = {
        ORG_Company_ID: this.ORG_Company_ID,
        ORG_Store_ID: this.info.ORG_Store_ID,
        GroupNo: data ? (data.PRDMenuAttachItemGroupNo ? data.PRDMenuAttachItemGroupNo : data.PRDAttachItemGroupNo) : null,
        moType: type,
        orgType: this.info.orgType,
      };
      this.EditAttachGMO.isShow = true;
    },
    onSave: (data) => {
      if (data.ORG_Store_ID != this.ORG_Store_ID) {
        alert(this.tt("common_group_store_must_match", "群組門市需要與商品門市一致!"));
        return;
      }
    },
    onClose(v) {
      this.isShow = false;
    },
  };

  DelAttachG(index) {
    this.mealData.AttachItemGroupJsonDatas.splice(index, 1);
  }

  getProductDetail(callback) {
    const par = {
      PRDGroupNo: this.info.PRDGroupNo,
      PRDProductNo: this.info.PRDProductNo,
      ORG_Store_ID: this.info.ORG_Store_ID,
    };
    this.http.post<any>("api/UsingMenu/GetProductDetail", par).subscribe({
      next: (data) => {
        if (data.LIST.length > 0) {
          const obj = data.LIST[0];
          obj.PRDGroupNo = obj.PRDProductGroupNo;
          this.toProductDetail(obj);
        }
      },
      error: (error) => {
        console.error("取得商品細項API error!", error);
      },
    });
  }

  getStoreList() {
    this.http.post<any>("api/ORGStore/StoreList", {
      USR_AccountInfo_ID: this.USR_AccountInfo_ID,
      ORG_Company_ID: this.ORG_Company_ID,
      ORG_Store_ID: this.ORG_Store_ID,
    }).subscribe({
      next: (data) => {
        this.info.storeList = [];
        let Item: any = {};
        Item.value = 0;
        Item.content = this.t("common_head_office");
        this.info.storeList.push(Item);

        if (this.ORG_Store_ID) {
          Item = {};
          Item.value = this.ORG_Store_ID;
          Item.content = data.LIST.find(x => x.ORG_Store_ID == this.ORG_Store_ID).StoreName;
          this.info.storeList.push(Item);
        } else {
          data.LIST.forEach(element => {
            const selectItem = new selectData();
            selectItem.value = element.ORG_Store_ID;
            selectItem.content = element.StoreName;
            this.info.storeList.push(selectItem);
          });
        }

        if (this.info.storeList.length > 0) {
          this.mealData.CopyStoreID = this.info.storeList[0].value;
        }
      },
      error: (error) => {
        console.error("There was an error!", error);
      },
    });
  }

  getGroupList() {
    if (this.info.orgType == 1) {
      const par = {
        ORG_Company_ID: this.ORG_Company_ID,
        CreateStore: this.mealData.CopyStoreID == null ? 0 : this.mealData.CopyStoreID,
        IsDelete: false,
      };
      this.http.post<any>("api/ProductSetting/GetProductGroup", par).subscribe({
        next: (data) => {
          this.info.groupList = [];
          data.LIST.forEach(element => {
            const item = new selectData();
            item.value = element.PRDGroupNo;
            item.content = element.GroupName;
            this.info.groupList.push(item);
          });

          if (this.info.groupList.length > 0) {
            this.mealData.PRDGroupNo = this.info.groupList[0].value.toString();
          }

          this.info.isChange_Group = !this.info.isChange_Group;
        },
        error: (error) => {
          console.error("There was an error!", error);
        },
      });
    }
  }

  trackByFn(i: number) {
    return i;
  }

  private applyTranslations() {
    this.TaxTypeList = [
      { value: 1, content: this.tt("common_tax_free", "免稅") },
      { value: 2, content: this.tt("common_taxable", "應稅") },
      { value: 3, content: this.tt("common_zero_tax", "零稅") },
    ];
  }

  private refreshSelects(): void {
    this.selectReady = false;
    setTimeout(() => {
      this.selectReady = true;
    });
  }

  t(key: string, fallback: string = ""): string {
    const text = this.translationService.getText(key);
    return !text || text === key ? (fallback || key) : text;
  }

  tt(key: string, fallback: string): string {
    return this.t(key, fallback);
  }
}

class ModifyPRDProductReq {
  PRDGroupNo: string;
  PRDMenuProductGroupNo: string;
  PRDProductNo: string;
  Main: any;
  Detail: any;
  USR_EmployeeInfo_ID: number;
  USR_AccountInfo_ID: string;
  ORG_Company_ID: number;
  ProductName: string;
  ProductContant: string;
  IsAIConentTranslate?: boolean;
  RemainingSYSQuota?: number;
  RemainingQuota?: number;
  Image: string;
  TaxRate: number = 5;
  TaxType: number = 2;
  Cash: number;
  SaleCash: number;
  Sorting: number;
  IsOpenTakeout: boolean = true;
  IsOpenDelivery: boolean = true;
  IsOpenDining: boolean = true;
  IsOpenReserveDining: boolean = false;
  IsOpenSelfPickup: boolean = true;
  IsChangeCash: boolean = true;
  IsSumSubtotalQty: boolean = true;
  SupplyQTY: number;
  UplimitQTY: number;
  SupplyDay: string;
  FirstSupplyStartTime: string;
  FirstSupplyEndTime: string;
  SecondSupplyStartTime: string;
  SecondSupplyEndTime: string;
  AttachItemGroupJsonDatas: AttachItemGroupJsonDataDTO[];
  AttachItemGroupJsonData: string;
  ProductLevelMapJsonData: ProductLevelMapJsonDataDTO[];
  pdlistDisposablesStr: string;
  supplyPeriod?: Array<supplyPeriod>;
  supplyDayStr: string;
  supplyTimeMonday?: boolean;
  supplyTimeTuesday?: boolean;
  supplyTimeWednesday?: boolean;
  supplyTimeThursday?: boolean;
  supplyTimeFriday?: boolean;
  supplyTimeSaturday?: boolean;
  supplyTimeSunday?: boolean;
  files: ImageFile[] = [];
  ORG_Store_ID?: number;
  CopyStoreID?: number;
}

class supplyPeriod {
  startTime: Date;
  endTime: Date;
}

class AttachItemGroupJsonDataDTO {
  PRDMenuAttachItemGroupNo: string;
  GroupName: string;
  Content: string;
  AttachItemKindName: string;
  IsRequiredName: string;
  Sorting: number;
}

class ProductLevelMapJsonDataDTO {
  usrMemberLevelIDs: string;
  memberLevelNames: string;
  takeoutSaleCash: number;
  deliverySaleCash: number;
  diningSaleCash: number;
  selfPickupSaleCash: number;
}

class ImageFile extends File {
  path: string;
}

class selectData {
  value: number;
  content: string;
}

class memberData {
  USR_MemberLevel_ID: string;
  MemberLevelName: string;
  isChecked: false;
}
